import { createSlice } from '@reduxjs/toolkit'

const paymentSlice = createSlice({
  name: 'paymentSlice',
  initialState: {
    paymentCardSlice: {},
    vendorInvoiceAdvanceDataSlice: [],
    paymentCardDataSlice: null,
    selectedPayment: []
  },
  reducers: {
    updatePaymentCardSlice: (state, action) => {
      state.paymentCardSlice = action.payload
    },

    updateVendorInvoiceAdvanceDataSlice: (state, action) => {
      state.vendorInvoiceAdvanceDataSlice = action.payload
    },

    updatePaymentCardDataSlice: (state, action) => {
      state.paymentCardDataSlice = action.payload
    },

    updateSelectedPaymentData: (state, action) => {
      state.selectedPayment = action.payload
  },
  },
})

export const {
  updatePaymentCardSlice,
  updateVendorInvoiceAdvanceDataSlice,
  updatePaymentCardDataSlice,
  updateSelectedPaymentData
} = paymentSlice.actions

export const paymentDataReducer = paymentSlice.reducer
